import { render, staticRenderFns } from "./PCRecord.vue?vue&type=template&id=7da3c07a"
import script from "./PCRecord.vue?vue&type=script&lang=js"
export * from "./PCRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports